module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-76x76-344883b964001574cc4b3860d36ed851.png";